import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { LeftArrow, RightArrow } from "../common/Icon";
const DescriptionSlider = () => {
  const [activeArrow, setActiveArrow] = useState("right");

  // Function to handle left arrow click
  const handleLeftArrow = () => {
    descripslide.current.slickPrev();
    setActiveArrow("left");
  };

  // Function to handle right arrow click
  const handleRightArrow = () => {
    descripslide.current.slickNext();
    setActiveArrow("right");
  };
  const descripslide = {
    dots: false,
    nextArrow: ".left-arrow",
    prevArrow: ".right-arrow",
    arrows: false,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <>
      <div className="rounded-xl px-4 lg:pl-5 lg:pr-[30px] py-[15px] bg-white shadow-workflow_item_card_shadow pb-14 relative md:ml-4 mb-4">
        <Slider {...descripslide} ref={descripslide}>
          <div>
            <p className="text-black font-normal italic text-sm">
              “If you want to be happy, set a goal that commands your thoughts,
              liberates your energy and inspires your hopes.”
            </p>
            <p className="pt-2 italic font-semibold text-sm text-black">
              — Andrew Carnegie
            </p>
          </div>
          <div>
            <p className="text-black font-normal italic text-sm">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro
              facere sequi ea at sint culpa laudantium eligendi iure autem.
            </p>
            <p className="pt-2 italic font-semibold text-sm text-black">
              Lorem ipsum,
            </p>
          </div>
        </Slider>
        <div>
          <button
            aria-label="Slider Arrow"
            onClick={handleLeftArrow}
            className={`common-arrow left-arrow w-full absolute left-[15px] bottom-[14px] ${
              activeArrow === "left" ? "opacity-1" : "opacity-50"
            }`}>
            <LeftArrow />
          </button>
          <button
            aria-label="Slider Arrow"
            onClick={handleRightArrow}
            className={`common-arrow right-arrow w-full absolute left-[25px] bottom-[14px]  ${
              activeArrow === "right" ? "opacity-1" : "opacity-50"
            }`}>
            <RightArrow />
          </button>
        </div>
      </div>
    </>
  );
};

export default DescriptionSlider;
